import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';

@Injectable({
  providedIn: 'root'
})
export class ProposalService {

  propostaBasePath: string;

  constructor(
    private api: ApiService,
    private localAccountService: LocalAccountService,
    private router: Router) {
    this.propostaBasePath = 'proposal';
  }

  checkIfIAmTheReceiver(user, element) {
    let ret = false;
    if (element.receiver && element.receiver.userId === user.userId) {
      ret = true;
    }
    return ret;
  }

  checkIfIAmTheSender(user, element) {
    let ret = false;
    if (element.sender && element.sender.userId === user.userId) {
      ret = true;
    }
    return ret;
  }

  async retrieveProposals(filterPurchasedSalesPackageId, filterString, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    // const url = this.propostaBasePath + `?filterString=${filterString}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
    const url = this.propostaBasePath + `?filterPurchasedSalesPackageId=${filterPurchasedSalesPackageId}&filterString=${filterString}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
    return this.api.getRequestPromise(url);
  }

  async getProposal(proposalId: string) {
    const url = this.propostaBasePath + `/${proposalId}`;
    return this.api.getRequestPromise(url);
  }

  async createProposal(body: any) {
    return this.api.postRequestPromise(this.propostaBasePath, body);
  }

  async cancelProposal(proposalId: string) {
    const url = this.propostaBasePath + `/${proposalId}/cancel`;
    return this.api.deleteRequestPromise(url);
  }

  async acceptProposal(proposalId: string, proposalItemId: string) {
    const url = this.propostaBasePath + `/${proposalId}/items/${proposalItemId}/accept`;
    return this.api.putRequestPromise(url, {});
  }

  async refuseForKO(proposalId: string) {
    const url = this.propostaBasePath + `/${proposalId}/refuseForKO`;
    return this.api.putRequestPromise(url, {});
  }

  async refuseForNewProposal(proposalId: string, body) {
    const url = this.propostaBasePath + `/${proposalId}/refuseForNewProposal`;
    return this.api.putRequestPromise(url, body);
  }
}
